/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import EventsIcon from 'icons/EventsIcon';

const messages = defineMessages({
  title: {id: 'navigation.events'},
});

const EventsItem = () => (
  <RouteLinkItem
    iconBefore={EventsIcon}
    route="midas/events/events"
    title={messages.title}
  />
);

export default EventsItem;
